import createCounterInlineFabric from "../../../general/CoreHeader/components/CounterInline/counterInlineFabric";
import { createDisplayNameForHeaderClose } from "../../utils/createDisplayName";
import { createTestIdForHeaderClose } from "../../utils/createTestId";

const displayName = createDisplayNameForHeaderClose("CounterInline");
const testId = createTestIdForHeaderClose("counter-inline");

const HeaderCloseCounterInline = createCounterInlineFabric(displayName, testId);

export default HeaderCloseCounterInline;
